<template>
  <div class="container">
    <div class="menu">
      <div class="title">
        <div class="sign"></div>
        {{ $t("route.companyProfile") }}
      </div>
      <div class="list" v-for="jtem in companyProfileList">
        <div class="item" @click="toMenu(jtem.path)">
          {{ jtem.title }}
        </div>
      </div>
    </div>
    <div class="menu">
      <div class="title">
        <div class="sign"></div>
        {{ $t("route.newsInformation") }}
      </div>
      <div class="list" v-for="jtem in newsList">
        <div class="item" @click="toMenu(jtem.path)">
          {{ jtem.title }}
        </div>
      </div>
    </div>
    <div class="menu">
      <div class="title">
        <div class="sign"></div>
        {{ $t("route.ProductCenter") }}
      </div>
      <div class="list" v-for="jtem in productCenterList">
        <div class="item" @click="toMenu(jtem.path)">
          {{ jtem.title }}
        </div>
      </div>
    </div>
    <div class="menu">
      <div class="title">
        <div class="sign"></div>
        {{ $t("route.Pilot") }}
      </div>
      <div class="list" v-for="jtem in pilotServiceList">
        <div class="item" @click="toMenu(jtem.path)">
          {{ jtem.title }}
        </div>
      </div>
    </div>
    <div class="menu">
      <div class="title">
        <div class="sign"></div>
        {{ $t("route.Contact") }}
      </div>
      <div class="list" v-for="jtem in contactList">
        <div class="item" @click="toMenu(jtem.path)">
          {{ jtem.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getChildCategory } from "@/api/acticle/acticle";
import { mixins } from "@/mixins/list";
export default {
  mixins: [mixins],
  data() {
    return {
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      getChildCategory({ name: "product_show" }).then((res) => {
        if (res.code === 0) {
          this.productCenterList = res.data.childrens.map((Element) => {
            return {
              id: Element.id,
              name: Element.title,
              title:
                localStorage.getItem("language") === "zh"
                  ? Element.title
                  : Element.en_title,
              path: `/productCenter/productCard/${Element.id}`,
            };
          });
        }
      });
    },
    toMenu(path) {
      if (["https://newlms.zhftc.com", "https://www.csairgroup.cn"].includes(path)) {
        window.open(path, "_blank");
        return;
      }
      this.$router.push(path);
      // this.$emit("resetScrollTop");
      this.$store.dispatch("user/resetScrollTop");
    },
  },
};
</script>

<style scoped>
.container {
  display: flex;
  flex-wrap: wrap;
  row-gap: 30px;
  /* justify-content: space-around; */
}
.menu {
  width: 33%;
}
.sign {
  width: 10px;
  height: 20px;
  margin-top: 5px;
  margin-right: 10px;
  float: left;
  background-color: #015a9c;
  border-radius: 5px;
}
.title {
  font-size: 20px;
  font-weight: 800;
  line-height: 30px;
  text-align: left;
  color: #015a9c;
  padding: 8px;
  border-radius: 10px;
  background-image: linear-gradient(
    90deg,
    #d5eeff 39.4064097767801%,
    rgba(255, 255, 255, 0) 100%
  );
}
.item {
  padding: 2px 2px 2px 20px;
  background-color: rgba(245, 245, 245, 0);
  box-sizing: border-box;
  font-family: "Arial Regular", "Arial";
  font-size: 18px;
  color: #333333;
  text-align: left;
  line-height: 25px;
  margin-top: 15px;
  cursor: pointer;
}
.item:hover {
  color: #015a9c;
  font-weight: 800;
}
@media only screen and (max-width: 768px) {
  .menu {
    width: 50%;
  }
  .title {
    font-size: 18px;
  }
  .item {
    font-size: 14px;
  }
}
</style>